var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import { Pie } from 'react-chartjs-2';
import { withTheme } from 'styled-components';
import { tooltipConfig } from './chart-integration';
import { get, set } from '../utils/funcs';
var defaultConfig = {};

var pieChart = function pieChart(_a) {
  var _b = _a.config,
      config = _b === void 0 ? defaultConfig : _b,
      pie = _a.pie,
      theme = _a.theme; // Our default library configuration for pie charts
  //alert(theme.themeName)

  var veryBackground = '#ffffff';
  var legendFontColor = '#000000';

  if (theme.themeName === 'dark') {
    veryBackground = '#343a40';
    legendFontColor = '#ffffff';
  }

  var libData = {
    datasets: [{
      borderColor: [],
      backgroundColor: [],
      data: pie.data || [],
      hoverBackgroundColor: []
    }],
    labels: config.labels || []
  };
  var libOptions = {
    cutoutPercentage: config.cutout || 0,
    animate: {
      animateRotate: config.rotate || 0
    },
    legend: {
      display: true,
      position: 'right',
      labels: {
        fontColor: legendFontColor
      }
    },
    tooltips: Object.assign(tooltipConfig(theme), {
      mode: 'point',
      callbacks: __assign(__assign({}, tooltipConfig(theme).callbacks), {
        label: function label(tooltipItem, data) {
          var index = get(tooltipItem, 'index', -1);
          var datasetIndex = get(tooltipItem, 'datasetIndex', -1);
          var label = get(config, "labels[" + index + "]", '');
          var value = get(data, "datasets[" + datasetIndex + "].data[" + index + "]", '');
          var formattedValue = config.formatter ? config.formatter(value) : value;
          return label + ": " + formattedValue;
        }
      })
    })
  };

  for (var i = 0; i < pie.data.length; i++) {
    set(libData, "datasets[0].borderColor[" + i + "]", veryBackground);
    set(libData, "datasets[0].backgroundColor[" + i + "]", theme.modularColor(i, 0, theme));
    set(libData, "datasets[0].hoverBackgroundColor[" + i + "]", theme.modularColor(i, -2, theme));
  }

  return React.createElement(Pie, {
    data: libData,
    options: libOptions
  });
};

export var ChartPie = withTheme(pieChart);